import EventBus from 'diagram-js/lib/core/EventBus';
import {EventType} from '@ispm/shared/bpmn-io/bpmn-js';
import {NodeType} from '@ispm/shared/bpmn-io/node-type';
import {ModelingUtil} from '@ispm/shared/bpmn-io/modeling-util';
import {select, Store} from '@ngrx/store';
import {selectNodesNamesSuffixes} from '../../store/selectors';
import {State} from '../../store/state';
import CommandInterceptor from "diagram-js/lib/command/CommandInterceptor";
import {MAX_TREATMENT_NODE_LABEL_STRING_NUM, SHIFT_COEFF} from "@ispm/shared/bpmn-io/bpmn-viewer-styling";
import {split} from 'lodash';

export class NodeNameEditor {
  private nodeNamesSuffixes: any;

  constructor(private eventBus: EventBus, private store$: Store<State>, private graphicsFactory, private elementRegistry) {
    this.store$.pipe(select(
      selectNodesNamesSuffixes
    )).subscribe(nodeNamesSuffixes => this.nodeNamesSuffixes = nodeNamesSuffixes);
    eventBus.on(EventType.SHAPE_ADDED, (event) => {
      if (ModelingUtil.getNodeType(event.element) === NodeType.treatment) {
        event.context = {node: event.element};
        this.editName(event);
      }
    });
  }

  private editName(event: any) {
    let node = event.context.node;
    if (this.nodeNamesSuffixes && this.nodeNamesSuffixes[node.id]) {
      node.businessObject.name = node.businessObject.name + '\n' + this.nodeNamesSuffixes[node.id];
      this.updateNodeAttributes(node);
      this.graphicsFactory.update('shape', node, this.elementRegistry.getGraphics(node));
    }
  }

  private updateNodeAttributes(node: any): any {

    const stringsNum = split(node.businessObject.name, '\n');
    // if we have additional strings we need to recalculate height and y
    if (stringsNum.length > MAX_TREATMENT_NODE_LABEL_STRING_NUM) {
      const addStrNum = stringsNum.length - MAX_TREATMENT_NODE_LABEL_STRING_NUM;
      const shift = Math.round(node.height * addStrNum * SHIFT_COEFF);
      node.height += addStrNum * shift;
      node.y -= Math.round((addStrNum * shift) / 2);
    }

    return node;
  }
}
NodeNameEditor.$inject = [...CommandInterceptor.$inject, 'store$', 'graphicsFactory', 'elementRegistry'];
